import React from 'react';

// Material-UI
import { TextField, CircularProgress } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

// ---------------------------------------------------------------------------------------------- \\
// ---------------------------------------- AUTOCOMPLETE ---------------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const CustomizedAutocomplete = ({ value, options, loading, onChange, onInputChange, placeholder }) => {
    return (
        <Autocomplete
            value={value}
            options={options}
            loading={loading}
            onChange={onChange}
            onInputChange={onInputChange}
            getOptionSelected={(option, value) => option.label === value.label}
            getOptionLabel={option => option.label}
            noOptionsText="Aucun"
            size="small"
            ListboxProps={{ style: { fontSize: 14 } }}
            renderInput={params => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                        style: { fontSize: 14 }
                    }}
                />
            )}
        />
    );
};

export default CustomizedAutocomplete;
